<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="width:100% !important">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->

                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">

                        <!--Name-->
                        <!-- <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="name" placeholder="Enter Name" v-model="name">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{nameError}}</span>
                            </div>
                        </div> -->

                        <!--Part Number-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Part Number :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="partNumber" placeholder="Enter Part Number" v-model="partNumber" v-on:input="onPartNoChange">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{partNumberError}}</span>
                            </div>
                        </div>

                      <!--Strip Part Number-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Strip Part Number :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input readonly class="form-control" id="strippartNumber" placeholder="Enter Strip Part Number" v-model="stripPartNumber">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{stripPartNumberError}}</span>
                            </div>
                        </div>

                        <!--Excede Id-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Excede ID :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="excedeId" placeholder="Enter Excede ID" v-model="excedeId">
                                <!-- <div class="requiredstar">*</div>
                                <span class="text-danger">{{excedeIdError}}</span> -->
                            </div>
                        </div>

                        <!--Excede SKU Id-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Excede SKU ID :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="excedeSkuId" placeholder="Enter Excede SKU ID" v-model="excedeSkuId">
                                <!-- <div class="requiredstar">*</div>
                                <span class="text-danger">{{excedeSkuIdError}}</span> -->
                            </div>
                        </div>
                        
                        <!--UPC Code-->
                        <!-- <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">UPC Code :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="upcCode" placeholder="Enter UPC Code" v-model="upcCode">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{upcCodeError}}</span>
                            </div>
                        </div> -->

                      <!--Desc-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Description :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" class="form-control" id="des" placeholder="Description" v-model="des">
                            </div>
                        </div>


                    </div>

                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary my-1 ms-2" v-on:click.prevent="addUpdateParts ()">
                        <input id="addAndContinueBenifitBtn" :disabled="disableButtons.saveAndContinue" type="submit" :value="buttonNames.saveAndContinue" class="btn btn-primary my-1 ms-2" v-on:click.prevent="addUpdateParts (flag='Save and Continue')">
                        <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateParts ()"></input>-->
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary my-1 ms-2" v-on:click.prevent="buttonBack">
                    </div>

                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';

    var moment = require('moment-timezone');

    export default {
        name: 'AddUpdateParts',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                pageTitle : "Add Parts",

                name : '',
                nameError : "",
                partNumber : "",
                stripPartNumber : "",
                partNumberError : "",
                stripPartNumberError : "",
                excedeId : "",
                excedeIdError : "",
                excedeSkuId : "",
                excedeSkuIdError : "",
                upcCode: "",
                upcCodeError: "",
                des: "",


                allPermissions : [],
                checkedPermissions : [],

                buttonNames : {
                    save : 'Save',
                    saveAndContinue : 'Save And Continue',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    saveAndContinue : false,
                    cancel : false
                },
                alertClass : '',
                alertMessage : '',
                permissionRendered : false,

            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "listParts");
        },

        watch: {

        },
        mounted: function () {
            // EventBus.$emit('showHeader', true);
            $("#alertError").hide();
            self.getAllPermissions();
            self.removeErrorMessageOnInput();
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[1] == 'update-part') {
                if (segments[2]) {
                    self.getPartDetailById();
                    self.buttonNames.save = "Update";
                    $("#addAndContinueBenifitBtn").hide();
                    // $("#addBenifitBtn").val("Update");
                    self.pageTitle = "Edit Parts";
                    $(".requiredstarPassword").hide();
                    $(".requiredstarConfirmPassword").hide();
                }
            }
        },
        beforeDestroy(){
            // EventBus.$off('all-permissions');
        },
        methods: {
            onPartNoChange(){
                //console.log(self.partNumber);
                self.stripPartNumber = self.partNumber.replace(/ /g,'');
            },
            removeErrorMessageOnInput : function () {
                /* Remove error on input */
                $("#name").keyup(function () {
                    self.nameError = "";
                });
                $("#partNumber").keyup(function () {
                    self.partNumberError = "";
                });
                $("#excedeId").keyup(function () {
                    self.excedeIdError = "";
                });
                $("#excedeSkuId").keyup(function () {
                    self.excedeSkuIdError = "";
                });
                $("#upcCode").keyup(function () {
                    self.upcCodeError = "";
                });
            },
            getAllPermissionsss(){
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.get("permission", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            self.allPermissions = data.data;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            showAlertOnSave : function (alertMessage, alertType) {
                if (alertType === "success") {
                    self.alertClass = "alert alert-success";
                } else {
                    self.alertClass = "alert alert-danger";
                }
                self.alertMessage = alertMessage;
                $("#success-alert").fadeTo(3000, 500).slideUp(500, function(){
                    $("#success-alert").slideUp(500);
                });
            },
            buttonBack : function () {
                self.$router.push('/list-parts');
            },
            clearDataOnSaveAndContinue : function () {
                self.name = '';
                self.partNumber = "";
                self.excedeId = "";
                self.excedeSkuId = "";
                self.stripPartNumber = "";
                self.des = "";
                self.upcCode = "";
            },
            checkForm: function () {
                var checked = true;
                var path = window.location.pathname;
                var segments = path.split("/");

                /* if (!self.name) {
                    self.nameError = "Name Required";
                    if (checked) {
                        checked = false;
                    }
                } */
                if (!self.partNumber) {
                    self.partNumberError = "Part Number Required";
                    if (checked) {
                        checked = false;
                    }
                }
                /* if (!self.excedeId) {
                    self.excedeIdError = "Excede ID Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.excedeSkuId) {
                    self.excedeSkuIdError = "Excede SKU ID Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.upcCode) {
                    self.upcCodeError = "UPC Code Required";
                    if (checked) {
                        checked = false;
                    }
                } */
                return checked;
            },
            getPartDetailById: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    customer_id: segments[2],
                };
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.post('/get-part-details-by-id', fields, config)
                    .then(response => {
                        self.name = response.data.customer.name;
                        self.partNumber = response.data.customer.part_no;
                        self.excedeId = response.data.customer.excede_id;
                        self.excedeSkuId = response.data.customer.excede_sku_id;
                        self.stripPartNumber = response.data.customer.strip_part_no;
                        self.des = response.data.customer.des;
                        self.upcCode = response.data.customer.upc_code;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            addUpdateParts (flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var config = {
                            headers: {Authorization:localStorage.getItem("access_token")},
                        };
                        if (segments[1] == 'update-part') {
                            if (segments[2]) {
                                var data = {
                                    name: self.name,
                                    part_number : self.partNumber,
                                    excede_id : self.excedeId,
                                    excede_sku_id : self.excedeSkuId,
                                    strip_part_number : self.stripPartNumber,
                                    des : self.des,
                                    upc_code : self.upcCode,
                                    id: segments[2],
                                };
                                self.buttonNames.save = "Updating ...";
                                self.disableButtons.save = true;
                                self.disableButtons.cancel = true;
                            } else {
                                if (flag == "Save and Continue") {
                                    self.buttonNames.saveAndContinue = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                } else {
                                    self.buttonNames.save = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                }
                            }
                        } else {
                            var data = {
                                name: self.name,
                                part_number : self.partNumber,
                                excede_id : self.excedeId,
                                excede_sku_id : self.excedeSkuId,
                                strip_part_number : self.stripPartNumber,
                                upc_code : self.upcCode,
                                des : self.des,
                            };
                            if (flag == "Save and Continue") {
                                self.buttonNames.saveAndContinue = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true
                            } else {
                                self.buttonNames.save = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true;
                            }
                        }

                        HTTP.post("/add-update-parts", data, config)
                            .then(function (response) {
                                EventBus.$emit('change_sidebar_menu', false, response.data.content);
                                if (segments[1] == 'update-part') {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    if (segments[2]) {
                                        self.buttonNames.save = "Update";
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                        } else {
                                            self.buttonNames.save = "Save";
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                    } else {
                                        self.buttonNames.save = "Save";
                                    }
                                }
                                if (response.data.status == "success") {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    EventBus.$emit('succes-message', response.data.user_message);
                                    //self.showAlertOnSave(response.data.user_message, "success");
                                    self.showSAlert(response.data.user_message,'success',false);
                                    if (flag == "Save and Continue") {
                                        self.clearDataOnSaveAndContinue();
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                    } else {
                                        setTimeout(function () {
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    self.disableButtons.save = false;
                                    self.disableButtons.saveAndContinue = false;
                                    self.disableButtons.cancel = false;
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i];
                                        }
                                        EventBus.$emit('succes-message', err);
                                        self.showSAlert(err,'error',false);
                                        // self.showAlertOnSave(err, "error");
                                    }
                                }
                            })
                            .catch(function (err) {
                                if (segments[1] == 'update-part') {
                                    if (segments[2]) {
                                        self.buttonNames = "Update";
                                        self.disableButtons.save = false;
                                        self.disableButtons.cancel = false;
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                            self.clearDataOnSaveAndContinue();
                                        } else {
                                            self.buttonNames.save = "Save";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                        self.clearDataOnSaveAndContinue();
                                    } else {
                                        self.buttonNames.save = "Save";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }
                                }
                            });
                    }
                }, 200);
            },
        }
    }
    EventBus.$on('all-permissions', function (isLogin, allPermissions) {
        if (typeof (self) != 'undefined') {
            self.allPermissions = [];
            for (var i = 0; i < allPermissions.length; i++) {
                var permissionNameArray = allPermissions[i].name.split("_");
                var permissionName = '';
                var permission = '';

                for (var j = 0; j < permissionNameArray.length; j++) {
                    permission = permissionNameArray[j].charAt(0).toUpperCase() + permissionNameArray[j].slice(1);
                    permissionName = permissionName +  " " + permission;
                }

                self.allPermissions.push({
                    'id' : allPermissions[i].id,
                    'name' : permissionName
                });
            }

            let path = window.location.pathname;
            let segments = path.split('/');

            if (segments[1] === 'update-part') {
                self.getPartDetailById();
            }
            // self.allPermissions = allPermissions;
        }
    });
</script>
<style>
    .field-icon {
        float: right;
        margin-right: 8px;
        margin-top: -23px;
        position: relative;
        z-index: 2;
        cursor:pointer;
    }
    .container{
        padding-top:50px;
        margin: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/Parts/AddUpdateParts.vue